module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('navigator', {
    attrs: {
      "selectedPerson": _vm.getSelectedPerson,
      "passedForm": _vm.getNewAgentSetup
    }
  }), _vm._v(" "), _c('steps', {
    attrs: {
      "currentStep": _vm.currentStep
    },
    on: {
      "changeCurrentStep": _vm.changeCurrentStep
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "new-agent flexGrow1"
  }, [_c(_vm.stepTemplate, {
    tag: "component",
    attrs: {
      "currentStep": _vm.currentStep,
      "passedForm": _vm.getNewAgentSetup,
      "showExistingAgentSelector": _vm.isAcceptingConnection,
      "is-disabled": _vm.isDisabled
    },
    on: {
      "formHaveErros": _vm.formHaveErros,
      "changeCurrentStep": _vm.changeCurrentStep,
      "cancelling": _vm.cancel,
      "goToNext": _vm.goToNext,
      "goToPrevious": _vm.goToPrevious,
      "readyToSave": _vm.readyToSave,
      "save": _vm.save
    }
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-bc00d31c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc00d31c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/people/agents/AgentNew.vue
// module id = 1241
// module chunks = 0